<template>
  <div>
    <br />
    <h5 class="pageTitle">Liste des conférences</h5>
    <conferences-list />
  </div>
</template>

<script>
  import ConferencesList from '../components/Conferences/Conferences_Liste';

  export default {
    name: 'conferences-page',
    components: { ConferencesList }
  };
</script>

<style scoped>
  p {
    margin-left: 0 !important;
  }

  a {
    font-size: 12px !important;
    text-decoration: underline;
  }
</style>
